import React from 'react';

export function PaymentPolicy() {
    return (
        <div className='w-full max-w-[1200px] flex flex-col justify-center items-center mx-auto py-4'>
            <h1 className='text-xl md:text-3xl text-white'>Kanema Online Subscription Policy</h1>
            <iframe
                src="https://drive.google.com/file/d/1ndXuabr9mllDwq_qOcFu7thEUxNdY14W/preview"
                className="w-full h-[650px] sm:h-[600px] md:h-[800px] mt-4"
                title="Payment Policy PDF"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
        </div>

    );
}
